import VueApexCharts from "vue-apexcharts";
import topDashboard from "@/views/dashboard/top/top.vue";
import dailyDashboard from "@/views/dashboard/daily/daily.vue";
import overviewDashboard from "@/views/dashboard/overview/overview.vue";
import {
    getUserGroup,
} from "@/service/account/manageUser";
import {
    getOverview,
    getTopreport,
    getLibCourse,
    getSumavg,

} from "@/service/dashboard/dashboard";

export default {

    components: {
        topDashboard,
        dailyDashboard,
        overviewDashboard,
        apexchart: VueApexCharts,
    },
    mounted() {
        this.initialize();
    },

    data() {
        return {
            resultOverview: {},
            resultTopreport: {},
            sendReportDaily: {},
            sendTopreport: {},
            sendOverview: {},
            dataParams: {},
            dataGroupSelect: [],
            dataIsGroupNull: false,
        }
    },
    watch: {

    },
    methods: {
        async initialize() {
            let datenow = new Date((new Date()).setHours(0, 0, 0, 0))
            let dataParams = {
                starttime: (new Date(datenow - (24 * 60 * 60 * 1000 * 6))).setHours(0, 0, 0, 0),
                endtime: datenow.getTime(),
                usergroup: this.dataGroupSelect,
            }
            let paramsG = {
                search: null,
                sort: "created_at",
                sortby: -1,
                usergroup: null,
                page: 1,
                limit: 100,
                active: "null",
            }
            let resultOverview = await getOverview(dataParams)
            // this.resultOverview = resultOverview;
            let dataGroup = await getUserGroup(paramsG)
            this.sendOverview = {
                resultOverview: resultOverview,
                dataGroup: dataGroup
            }
            this.sendReportDaily = {
                getLibCourse: await getLibCourse(dataParams),
                getSumavg: await getSumavg(dataParams),
                dataParams: dataParams
            }
            this.sendTopreport = {
                resultTopreport: await getTopreport(dataParams),
                resultOverview: resultOverview
            }





        },
        sendDataGroupSelect(value, groupnull) {
            this.dataGroupSelect = value;
            this.dataIsGroupNull = groupnull;

        }
    }
}